/* A purchase shortcut that delegates to the live Shopify product form. */
(() => {
  if (window.__coinyPurchaseV5) return;
  window.__coinyPurchaseV5 = true;
  const initialized = new WeakSet();
  const mobile = window.matchMedia('(max-width: 800px)');
  const cookieSelector = '#shopify-pc__banner, .shopify-pc__banner, #onetrust-banner-sdk, #CybotCookiebotDialog, [data-cookie-banner], .cc-window, .osano-cm-window';
  const chatSelector = '#shopify-chat, #ShopifyChat, shopify-chat, #gorgias-chat-container, #intercom-container, .intercom-lightweight-app, iframe[title*="chat" i], iframe[id*="chat" i]';

  function visibleRect(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return null;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth ? rect : null;
  }

  function initialize(bar) {
    if (initialized.has(bar)) return;
    initialized.add(bar);
    const action = bar.querySelector('[data-cm-v5-buy-action]');
    const label = bar.querySelector('[data-cm-v5-buy-label]');
    const quantityLabel = bar.querySelector('[data-cm-v5-quantity]');
    const status = bar.querySelector('[data-cm-v5-buy-status]');
    const productId = bar.dataset.productId;
    let primary = null;
    let form = null;
    let boundScope = null;
    let queued = false;
    let lastOffset = -1;
    let wasCartOpen = false;
    let restoreAfterCart = false;
    const formObserver = new MutationObserver(schedule);
    const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(schedule) : null;

    function findForm() {
      const scope = document.querySelector(`#MainContent product-info[data-product-id="${CSS.escape(productId)}"]`) || document.querySelector('.preview-product-info');
      const candidate = scope?.querySelector('product-form button[name="add"], .cm-add-form button[type="submit"]');
      if (candidate === primary) return;
      formObserver.disconnect();
      intersection?.disconnect();
      primary = candidate;
      form = primary?.form || primary?.closest('form');
      boundScope = scope;
      if (scope) formObserver.observe(scope, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy','hidden','class','value']});
      if (primary) intersection?.observe(primary);
    }

    function obstacles() {
      if (document.querySelector('dialog[open], cart-drawer.active, cart-notification.active, .preview-bag[open]')) return {blocked:true,offset:0};
      const menu = document.querySelector('#cm-mobile-menu:not([hidden])');
      if (visibleRect(menu)) return {blocked:true,offset:0};
      const active = document.activeElement;
      if (active && active !== action && (active.matches('input:not([type="button"]):not([type="submit"]), textarea, select') || active.isContentEditable)) return {blocked:true,offset:0};
      if (window.visualViewport && window.innerHeight - window.visualViewport.height > 150) return {blocked:true,offset:0};
      for (const element of document.querySelectorAll(cookieSelector)) if (visibleRect(element)) return {blocked:true,offset:0};
      let lift = 0;
      for (const element of document.querySelectorAll(chatSelector)) {
        const rect = visibleRect(element);
        if (!rect || rect.bottom < innerHeight - 160) continue;
        // An open panel gets the whole viewport. A compact launcher gets room below the bar.
        if (rect.width > innerWidth * .55 || rect.height > 160) return {blocked:true,offset:0};
        lift = Math.max(lift, innerHeight - rect.top + 12);
      }
      const external = parseFloat(getComputedStyle(bar).getPropertyValue('--cm-v5-bottom-offset')) || 0;
      return {blocked:false,offset:Math.max(0, lift - external)};
    }

    function sync() {
      queued = false;
      if (!bar.isConnected) return;
      findForm();
      if (!primary || !form || !mobile.matches) {bar.hidden = true; return;}
      const rect = primary.getBoundingClientRect();
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cm-header-height')) || 0;
      const busy = primary.getAttribute('aria-disabled') === 'true' || primary.getAttribute('aria-busy') === 'true' || primary.classList.contains('loading');
      const unavailable = primary.disabled || form.elements.namedItem('id')?.disabled;
      const cartOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active, .preview-bag[open]'));
      const cartJustClosed = wasCartOpen && !cartOpen;
      wasCartOpen = cartOpen;
      const overlay = obstacles();
      const viewportBottom = Math.min(innerHeight, (window.visualViewport?.offsetTop || 0) + (window.visualViewport?.height || innerHeight));
      const outsidePrimary = rect.width > 0 && rect.height > 0 && (rect.bottom <= headerHeight || rect.top >= viewportBottom);
      const errorWrapper = boundScope.querySelector('.product-form__error-message-wrapper:not([hidden])');
      const nativeError = errorWrapper?.querySelector('.product-form__error-message')?.textContent.trim() || '';
      if (status.textContent !== nativeError) status.textContent = nativeError;
      status.hidden = !nativeError;
      const quantity = Math.max(1, parseInt(form.elements.namedItem('quantity')?.value || '1',10) || 1);
      const quantityText = quantity > 1 ? ` each · Qty ${quantity}` : '';
      if (quantityLabel.textContent !== quantityText) quantityLabel.textContent = quantityText;
      action.disabled = Boolean(unavailable || busy);
      action.setAttribute('aria-busy', String(busy));
      const buttonText = busy ? 'Adding…' : 'Add to cart';
      if (label.textContent !== buttonText) label.textContent = buttonText;
      if (lastOffset !== overlay.offset) {bar.style.setProperty('--cm-v5-obstacle-offset', `${overlay.offset}px`); lastOffset = overlay.offset;}
      bar.hidden = !outsidePrimary || Boolean(unavailable || busy) || overlay.blocked;
      if (cartJustClosed && restoreAfterCart) {
        restoreAfterCart = false;
        const active = document.activeElement;
        if (!bar.hidden && (!active || active === document.body || active.closest('cart-drawer, cart-notification, .preview-bag'))) action.focus({preventScroll:true});
      }
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }

    action.addEventListener('click', () => {
      findForm();
      if (!primary || bar.hidden || action.disabled || primary.disabled || primary.getAttribute('aria-disabled') === 'true' || primary.getAttribute('aria-busy') === 'true' || primary.classList.contains('loading')) return;
      // Click the actual form button; Shopify owns quantity, inventory, checkout and success/error state.
      restoreAfterCart = true;
      primary.click();
      schedule();
    });
    document.addEventListener('input', schedule);
    document.addEventListener('change', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('close', schedule, true);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.visualViewport?.addEventListener('resize', schedule, {passive:true});
    mobile.addEventListener?.('change', schedule);
    // Observe overlay state and app injection. Ignore the bar's own state changes to avoid feedback loops.
    const overlays = new MutationObserver(records => {
      if (records.some(record => !bar.contains(record.target))) schedule();
    });
    overlays.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['open','class','hidden','aria-hidden','style']});
    findForm();
    schedule();
  }

  function initializeAll() {document.querySelectorAll('[data-cm-v5-buy]').forEach(initialize);}
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('product-info:loaded', initializeAll);
})();
